/* eslint-disable react/prop-types */
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { getPathAlias } from 'tw-oi-core/utils/vehicle'
import * as VehicleActions from 'tw-oi-core/actions/VehicleActions'

import { ROUTE, BRANDS, MESSAGE } from '../config'
import Loader from '../components/Loader'
import ErrorMessage from '../components/ErrorMessage'

class VehicleRedirect extends Component {
  componentDidMount() {
    this.loadOrRedirect()
  }

  componentDidUpdate(prevProps) {
    const { match: { params: { id } }, vehicle: { vehicles } } = this.props
    const { match: { params: { id: prevId } }, vehicle: { vehicles: prevVehicles } } = prevProps

    if (id !== prevId || vehicles !== prevVehicles) {
      this.loadOrRedirect()
    }
  }

  loadOrRedirect() {
    const { vehicle: { vehicles }, VehicleActions } = this.props
    if (vehicles === null) {
      VehicleActions.getVehicles()
      return
    }
    this.tryRedirect()
  }

  tryRedirect() {
    const { match: { params: { id } }, vehicle: { vehicles }, history } = this.props
    if (!vehicles) return

    const targetVehicle = vehicles.find(v => String(v.id) === String(id))
    if (!targetVehicle) return

    const brand = BRANDS.find(b => b.name === targetVehicle.make)
    if (!brand) return

    const modelSlug = getPathAlias(`${targetVehicle.id} ${targetVehicle.model}`)
    history.replace(`/${brand.key}${ROUTE.GUIDE}/${targetVehicle.year}/${modelSlug}${ROUTE.BROWSE}`)
  }

  render() {
    const { match: { params: { id } }, vehicle: { vehicles, error }, VehicleActions } = this.props

    if (error) {
      return <ErrorMessage className="inverse" retryAction={() => VehicleActions.getVehicles()} />
    }

    if (vehicles === null) {
      return <Loader className="inverse" />
    }

    const targetVehicle = vehicles.find(v => String(v.id) === String(id))

    if (!targetVehicle) {
      return (
        <ErrorMessage
          className="inverse"
          title={MESSAGE.ERROR_VEHICLE_NOT_FOUND}
          retryAction="/"
          retryTitle="Visit Home Page"
          message={MESSAGE.ERROR_VEHICLE_RETRY}
        />
      )
    }

    const brand = BRANDS.find(b => b.name === targetVehicle.make)

    if (!brand) {
      return (
        <ErrorMessage
          className="inverse"
          title={MESSAGE.ERROR_VEHICLE_NOT_FOUND}
          retryAction="/"
          retryTitle="Visit Home Page"
          message={MESSAGE.ERROR_VEHICLE_RETRY}
        />
      )
    }

    return <Loader className="inverse" />
  }
}

function mapStateToProps({ vehicle }) {
  return { vehicle }
}

function mapDispatchToProps(dispatch) {
  return { VehicleActions: bindActionCreators(VehicleActions, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(VehicleRedirect)
